(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 27627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(21495);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50675);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47741);
/* harmony import */ var components_inputs_InputTextGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80929);
/* harmony import */ var components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64070);
/* harmony import */ var components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61053);
/* harmony import */ var hooks_useCatchError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65633);
/* harmony import */ var layouts_RootLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89806);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35656);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87536);
/* harmony import */ var respository_auth_repository__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71219);













const ForgotPasswordPage = ()=>{
    // use react-hook-form
    const { control , handleSubmit  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)();
    // use catch error
    const catchErrors = (0,hooks_useCatchError__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)([
        "auth",
        "common"
    ]);
    // loading state
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    // is reset password success
    const [isResetPasswordSuccess, setIsResetPasswordSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const [curentEmail, setCurentEmail] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
    // handle submit
    const submit = async (values)=>{
        console.log(values);
        try {
            setLoading(true);
            // fake api call promise
            const data = await respository_auth_repository__WEBPACK_IMPORTED_MODULE_8__/* .AuthRepository.sendResetPassword */ .O.sendResetPassword({
                email: values.email
            });
            if (data && data.success) {
                setIsResetPasswordSuccess(true);
                setCurentEmail(values.email);
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            catchErrors(error);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: t("auth.forgotPassword.title", {
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: t("auth.forgotPassword.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        children: t("auth.forgotPassword.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Container */ .W2, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                            pt: {
                                base: 4,
                                md: 8
                            },
                            pb: {
                                base: 10,
                                md: 12,
                                lg: 24
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Heading */ .X6, {
                                    mb: {
                                        base: 2,
                                        md: 4
                                    },
                                    fontSize: {
                                        base: "xl",
                                        lg: "2xl"
                                    },
                                    fontWeight: 400,
                                    children: [
                                        t("auth.forgotPassword.title"),
                                        "?"
                                    ]
                                }),
                                isResetPasswordSuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            fontSize: "5xl",
                                            color: "green",
                                            mb: 1,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Heading */ .X6, {
                                                    mb: 1,
                                                    children: t("auth.forgotPassword.success.title", {
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                                    fontSize: "lg",
                                                    children: curentEmail
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                            fontSize: "lg",
                                            mb: 4,
                                            children: t("auth.forgotPassword.description")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                            onSubmit: handleSubmit(submit),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                width: "250px",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs_InputTextGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        name: "email",
                                                        type: "email",
                                                        label: t("form.label.email", {
                                                            ns: "common"
                                                        }),
                                                        control: control,
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: t("form.message.required", {
                                                                    ns: "common"
                                                                })
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                                        mt: 4,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .zx, {
                                                            type: "submit",
                                                            width: "100%",
                                                            bg: "gray.800",
                                                            isLoading: loading,
                                                            children: t("ok", {
                                                                ns: "common"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
ForgotPasswordPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_RootLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ForgotPasswordPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,2077,5237,9806,2035,9774,2888,179], function() { return __webpack_exec__(27627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);